import React from 'react';
import {Box, CircularProgress, Typography} from '@mui/material';

export type LoadingScreenProps = {
  fullScreen?: boolean;
  message?: string;
};

const LoadingScreen: React.FC<LoadingScreenProps> = ({fullScreen = true, message}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height={fullScreen ? '100vh' : '100%'}
      width="100%"
    >
      <CircularProgress />
      {message && (
        <Typography variant="body2" color="text.secondary" mt={2}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingScreen;
